module.exports = __webpack_public_path__ + "static/media/slidePicture2.05fccbf3.jpg";